import React, { useContext } from 'react';
import { Container, Button } from 'reactstrap';
import { parseISO, differenceInDays } from 'date-fns';
import { AppContext } from '../../../context/app-context';
import { checkMyDietPlan, sendFirebaseEvent } from '../../../helper/mobile';
import DietPlanCard from '../Category/DietPlanCard';
import FreeFeature from './FreeFeature';
import PaidFeature from './PaidFeature';
import SuccessHeader from './SuccessHeader';
// import { useDiet } from '../../../hooks/useDiet';
import { useNavigate } from 'react-router-dom';

const aiDietPlan = ['one_month_smart_diet_plan', 'three_month_smart_paid_diet_plan', 'one_month_smart_paid_diet_plan'];

const DietPlanSuccess = ({dietPlan}) => {

    let navigate = useNavigate();
    const [state, dispatch] = useContext(AppContext);
    const { existingDietplan } = state;
    console.log("statestatestatestate", state);
    const pEndDate = parseISO(existingDietplan.planEndDate);
    const dateDiff = differenceInDays(pEndDate, new Date());
    // const { upgradeRequestCall } = useDiet();

    const handleOnClick = () => {
        sendFirebaseEvent('diet_plan_view_click', 'click_event', 'diet_plan_status');
        checkMyDietPlan();
    }

    const onClickUpgrade = () => {
        sendFirebaseEvent('diet_plan_upgrade_my_plan_click', 'click_event', existingDietplan?.dietPlanType);
        navigate(`/dietPlan/${existingDietplan.dietPlanId}/payment/true`);
    }

    // const onClickUpgradeRequestCall = () => {
    //     sendFirebaseEvent('diet_plan_upgrade_my_plan_click', 'click_event', dietPlan.dietPlanType);
    //     upgradeRequestCall();
    // }

    return (
        <>
            <SuccessHeader dietPlan={existingDietplan} />
            <Container className='margin-minus-1'>
                <DietPlanCard dietPlan={existingDietplan} />
            </Container>
                <FreeFeature dietPlan={existingDietplan} />
                {/* {
                    dateDiff < 7 ? <div className="empty-space-150"></div> : <div className="empty-space-82"></div>
                } */}
                <div className="empty-space-82"></div>
                <div className="fix-div-button">
                    {/* {
                        !['one_month_diet_plan_subscription', 'three_month_diet_plan_subscription', 'six_month_diet_plan_subscription'].includes(dietPlan.dietPlanType) && dateDiff < 7 && <Button className="risk-btn mb-3" onClick={onClickUpgrade}>Upgrade my plan</Button>
                    } */}
                    <Button className="risk-btn risk-btn-outline" onClick={handleOnClick}>View my diet plan</Button>
                </div>
        </>
    );
}

export default DietPlanSuccess;